import page from './page';
export default page;



// WEBPACK FOOTER //
// ./src/components/page/index.js